// extracted by mini-css-extract-plugin
export var dropdownButton = "_1n-0";
export var fullWidthDropdownButton = "_1n-1";
export var icon = "_1n-3";
export var iconPlaceholder = "_1n-2";
export var shortcutContainer = "_1n-4";